/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 19cbf1f79c38
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Fetch-based delivery types for assets retrieved from remote URLs.
 */
export const FetchDeliveryType = {
  Fetch: "fetch",
  Url2png: "url2png",
} as const;
/**
 * Fetch-based delivery types for assets retrieved from remote URLs.
 */
export type FetchDeliveryType = ClosedEnum<typeof FetchDeliveryType>;

export const FetchDeliveryType$zodSchema = z.enum([
  "fetch",
  "url2png",
]).describe(
  "Fetch-based delivery types for assets retrieved from remote URLs.",
);
